/**
 * Takes an array and split it into chunks of size chunkSize
 * @param {any[]} list array to split
 * @param {number} chuckSize chunk size
 */
export const chunkArray = (list, chuckSize) => {
  return new Array(Math.ceil(list.length / chuckSize)).fill().map((_, i) => list.slice(i * chuckSize, i * chuckSize + chuckSize));
};

/**
 * Chunk array into exact chunk size sub arrays
 * @param {any[]} list - array to split
 * @param {number} chunkSize - chunk size
 * @returns chunked array 
 */
export const chunkArrayExact = (list, chunkSize) => {
  const chunkedArray = Array.from(new Array(chunkSize), () => []);

  const itemsPerLine = Math.ceil(list.length / chunkSize);

  for (let line = 0; line < chunkSize; line++) {
    for (let i = 0; i < itemsPerLine; i++) {
      const value = list[i + line * itemsPerLine];
      if (!value) continue; //avoid adding "undefined" values
      chunkedArray[line].push(value);
    }
  }
  return chunkedArray;
};